import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-10 relative z-20">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => {
          const colorClasses =
            cat.color === 'primary'
              ? 'bg-primary-500 hover:bg-primary-600'
              : cat.color === 'accent'
                ? 'bg-accent-500 hover:bg-accent-600'
                : 'bg-secondary-500 hover:bg-secondary-600';

          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`${colorClasses} rounded-xl p-4 md:p-5 text-background-50 no-underline transition-all duration-300 group`}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background-50/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-bold text-sm md:text-base mb-1">{cat.name}</h3>
              <p className="text-xs text-background-50/80 hidden sm:block">
                {cat.description}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}